import * as turf from "@turf/turf";
export class MatrixTools {
    static cloneMatrix(matrix) {
        return {
            name: matrix.name,
            locations: matrix.locations.map(x => {
                return {
                    longitude: x.longitude,
                    latitude: x.latitude,
                    properties: x.properties
                };
            }),
            elements: matrix.elements.map(x => {
                return {
                    fromIdx: x.fromIdx,
                    toIdx: x.toIdx,
                    count: x.count,
                    properties: x.properties
                };
            }),
            properties: matrix.properties,
        };
    }
    static buildFeatures(matrix) {
        const features = [];
        matrix.locations.forEach((l, i) => {
            const properties = {
                id: i,
                name: l.properties?.name,
                matrix_id: matrix.id,
                type: "location",
                location_type: l.properties?.type ?? "unknown",
            };
            if (properties.name === undefined ||
                properties.name === `${i}`) {
                delete properties.name;
            }
            features.push(turf.point([l.longitude, l.latitude], properties));
        });
        console.log(features);
        matrix.elements.forEach((m, i) => {
            const from = matrix.locations[m.fromIdx];
            const to = matrix.locations[m.toIdx];
            features.push(turf.lineString([
                [from.longitude, from.latitude],
                [to.longitude, to.latitude],
            ], {
                type: "movement",
                id: i,
                name: i,
                count: m.count,
                matrix_id: matrix.id
            }));
        });
        return features;
    }
}
